import { Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import colors from '@/common/colors';
import fontStyles from '@/common/fontStyles';
import { mobileStartBreakpoint } from '@/materialUi/theme';

const useLiveAgentStyles = makeStyles((theme: Theme) => createStyles({
  bold: {
    fontWeight: 600
  },
  chatBtn: {
    ...fontStyles.primaryCtaLabel,
    'text-transform': 'uppercase',
    textAlign: 'center',
    fontSize: '16px',
    padding: '6px 0 7px 0',
    '&:disabled': {
      backgroundColor: colors.gray601,
      color: colors.white
    },
    [theme.breakpoints.down(mobileStartBreakpoint)]: {
      width: '100%'
    },
    [theme.breakpoints.up(mobileStartBreakpoint)]: {
      width: '280px'
    }
  }
}));

export default useLiveAgentStyles;
